import { type IPlaceListResponse } from '@/entities/place'
import { PlaceSearchItem } from '@/features/seoPlaceSearch/ui/PlaceSearchItem'
import { DividerHorizontal } from '@/shared/design-system/components/Divider'
import { COMMON_ERROR_DESCRIPTION, COMMON_ERROR_TITLE } from '@/shared/lib'
import { Result } from '@/shared/ui'

const PlaceRecommendList = ({
  data,
  isError,
  handleRetryPlaceList,
}: {
  data: IPlaceListResponse | undefined
  isError: boolean
  handleRetryPlaceList: () => void
}) => {
  return (
    <>
      <ul>
        {data?.content?.map((item, index) => (
          <li key={item.serverId}>
            <PlaceSearchItem place={item} isRecommended />
            <div className='px-5'>
              {index !== data?.content?.length - 1 && (
                <DividerHorizontal
                  h='h-stroke-width-x1'
                  color='bg-stroke-neutral-normal'
                />
              )}
            </div>
          </li>
        ))}

        {isError && (
          <Result
            title={COMMON_ERROR_TITLE}
            description={COMMON_ERROR_DESCRIPTION}
            handleRetry={handleRetryPlaceList}
          />
        )}
      </ul>
    </>
  )
}

export default PlaceRecommendList
